// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__10UJr","fileDisabled":"File_fileDisabled__3pRYV"};